import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=5ef9f563&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=ts"
export * from "./ContactsPage.vue?vue&type=script&lang=ts"
import style0 from "./ContactsPage.vue?vue&type=style&index=0&id=5ef9f563&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9f563",
  null
  
)

export default component.exports